import FrenchLocaleProvider from "./components/FrenchLocaleProvider";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../src/context/AuthContext";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Assure-toi d'importer les styles nécessaires

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FrenchLocaleProvider>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
      {/* Déplace le ToastContainer ici, juste à l'extérieur de AuthProvider */}
      <ToastContainer
        autoClose={1500}
        position="top-center"
        transition={Slide}
      />
    </BrowserRouter>
    </FrenchLocaleProvider>
  </React.StrictMode>,
);

// Si tu veux mesurer la performance de ton application, tu peux utiliser reportWebVitals
reportWebVitals();
